import YSelect from './src/main'

YSelect.install = function (Vue) {
  Vue.component(YSelect.name, YSelect)
}

export default YSelect
